const DROPBOX_HOSTS = new Set(['www.dropbox.com', 'dropbox.com', 'dl.dropboxusercontent.com']);

export function isDropboxHost(url: URL): boolean {
  const hostname = url.hostname.toLowerCase().replace(/\.$/, '');
  return ['dropbox.com', 'dropboxusercontent.com', 'dropboxapi.com']
    .some((domain) => hostname === domain || hostname.endsWith(`.${domain}`));
}

export function validateDropboxFileLink(value: string): void {
  const invalid = () => { throw new Error('DROPBOX_INVALID_LINK'); };
  let url: URL;
  try { url = new URL(value); } catch { return invalid(); }
  if (!/^https:\/\//i.test(value) || value.length > 4096 || value !== value.trim() || /[\s\\]/.test(value)
    || Array.from(value).some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)
    || !DROPBOX_HOSTS.has(url.hostname) || url.protocol !== 'https:' || url.username || url.password || url.port) return invalid();
  const folderFile = url.pathname.match(/^\/scl\/fo\/[A-Za-z0-9_-]{1,256}\/[A-Za-z0-9_-]{1,256}\/([^/]+)$/);
  if (/^\/(scl\/fo|sh)(\/|$)/.test(url.pathname) && !folderFile) throw new Error('DROPBOX_FOLDER_UNSUPPORTED');
  const file = url.pathname.match(/^\/(scl\/fi|s)\/[A-Za-z0-9_-]{1,256}\/([^/]+)$/);
  if (!file && !folderFile) return invalid();
  let filename: string;
  try { filename = decodeURIComponent(folderFile?.[1] ?? file![2]); } catch { return invalid(); }
  if (!filename || filename.length > 512 || ['.', '..'].includes(filename) || /[/\\]/.test(filename)
    || Array.from(filename).some((char) => char.charCodeAt(0) < 32 || char.charCodeAt(0) === 127)) return invalid();
  if (folderFile && !/\.(mp4|mov|m4v|mkv|webm)$/i.test(filename)) throw new Error('DROPBOX_FOLDER_UNSUPPORTED');
  const keys = url.searchParams.getAll('rlkey');
  if (keys.length > 1 || ((folderFile || file?.[1] === 'scl/fi') && keys.length !== 1)
    || (keys.length === 1 && !/^[A-Za-z0-9_-]{1,256}$/.test(keys[0]))) return invalid();
}
